import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]
  static values = { visible: { type: Boolean, default: false } }

  connect() {
    document.addEventListener("position-descriptions:show-all", this.showAllHandler = () => this.show())
  }

  disconnect() {
    document.removeEventListener("position-descriptions:show-all", this.showAllHandler)
  }

  show() {
    this.visibleValue = true
  }

  remove() {
    this.visibleValue = false
    document.dispatchEvent(new CustomEvent("position-description:removed"))
  }

  visibleValueChanged(visible) {
    this.element.classList.toggle("hidden", !visible)
    if (!visible && this.hasTextareaTarget) {
      this.textareaTarget.value = ""
    }
    this.element.closest("[data-position-row]")?.classList.toggle("has-description", visible)
  }
}
